//
//
//

const mixins = {
  methods: {
    actionkey(shortkey, route, click) {
      // alert(shortkey);
      if (!click && this.$router.currentRoute.path !== '/') return
      if (shortkey == 'esc') {
        this.exit()
      } else {
        switch (shortkey.length) {
          case 1:
            // alert(route)
            var add = ['invoices', 'lendings', 'receipts', 'payments', 'transfers'].includes(route)
            var bill = ['persons', 'products', 'bank_accounts', 'boxes', 'costs', 'incomes', 'fiscal_years'].includes(route)
            if (add) {
              if (click) {
                window.location.href = `/${route}/add`
              } else {
                this.$router.push(`/${route}/add`)
              }
            } else if (bill) {
              if (click) {
                window.location.href = `/${route}/bill/1`
              } else {
                this.$router.push(`/${route}/bill/1`)
              }
            } else if (route === 'periodReport') {
              const _url = `/reports/period`
              if (click) {
                window.location.href = _url
              } else {
                this.$router.push(_url)
              }
            } else if (route === 'charts') {
              const _url = `/reports/charts`
              if (click) {
                window.location.href = _url
              } else {
                this.$router.push(_url)
              }
            } else if (route === 'initBalance') {
              const _url = `/balances/init`
              if (click) {
                window.location.href = _url
              } else {
                this.$router.push(_url)
              }
            } else if (route === 'currentBalance') {
              const _url = `/balances/current`
              if (click) {
                window.location.href = _url
              } else {
                this.$router.push(_url)
              }
            } else if (route === 'daily') {
              const _url = `/reports/daily`
              if (click) {
                window.location.href = _url
              } else {
                this.$router.push(_url)
              }
            } else if (route == 'cheques') {
              if (click) {
                window.location.href = `/${route}/page/1`
              } else {
                this.$router.push(`/${route}/page/1`)
              }
            } else if (['bank_bill', 'bank_control'].includes(route)) {
              if (click) {
                window.location.href = `/${route}`
              } else {
                this.$router.push(`/${route}`)
              }
            }
            break;
          case 2:
            if (shortkey[0] == 'ctrl') {
              if (click) {
                window.location.href = `/${route}/page/1`
              } else {
                this.$router.replace(`/${route}/page/1`)
              }
            } else if (shortkey[0] == 'alt') {
              if (click) {
                window.location.href = `/${route}/report`
              } else {
                this.$router.replace(`/${route}/report`)
              }
            }
            break;
          case 3:
            if (shortkey[0] == 'ctrl' && shortkey[1] == 'alt') {
              if (click) {
                window.location.href = `/${route}/page/1`
              } else {
                this.$router.replace(`/${route}/page/1`)
              }
            }
            break;
          default:
        }
      }
    },
    calculateDiscount({
      total,
      base = 10000,
      discountLabel,
      route
    }) {
      if (!total || !discountLabel) return '0'

      // رفع خطای اعشاری با رند کردن تا دو رقم اعشار
      total = total.toFixed(0)
      // total = Math.round(total * 100) / 100
      // console.log(total);
      const roundTotal = Math.round(total / base) * base
      const diff = total - roundTotal

      if (diff === 0) return '0'

      let kasr = diff > 0 ? diff : base - Math.abs(diff)
      let ezafe = diff > 0 ? base - diff : Math.abs(diff)

      // اطمینان از اینکه خروجی منفی نباشه
      kasr = kasr < 0 ? 0 : kasr
      ezafe = ezafe < 0 ? 0 : ezafe

      const ruleTable = {
        receipts: {
          cost_id: true,
          income_id: false
        },
        payments: {
          cost_id: false,
          income_id: true
        },
        buy: {
          cost_id: true,
          income_id: false
        },
        sale: {
          cost_id: false,
          income_id: true
        }
      }

      const shouldUseEzafe = ruleTable?.[route]?.[discountLabel] ?? false
      let discountPrice = shouldUseEzafe ? ezafe : kasr

      if (discountPrice > base) discountPrice = base

      return Math.floor(discountPrice)
    },
  }
}

export default mixins
